import * as React from "react";
const SvgFiRrCar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-car_svg__a)">
      <path
        fill="#062147"
        d="M20.9 4.291A5.01 5.01 0 0 0 16.2 1H7.8a5.01 5.01 0 0 0-4.7 3.291L.4 11.718A6.7 6.7 0 0 0 0 14v1a4.98 4.98 0 0 0 2 3.978V21a3 3 0 0 0 6 0v-1h8v1a3 3 0 0 0 6 0v-2.022A4.98 4.98 0 0 0 24 15v-1a6.7 6.7 0 0 0-.4-2.281zm-15.918.684A3.01 3.01 0 0 1 7.8 3h8.4a3.01 3.01 0 0 1 2.82 1.975L21.208 11H2.791zM6 21a1 1 0 1 1-2 0v-1.1q.495.1 1 .1h1zm14 0a1 1 0 0 1-2 0v-1h1q.505 0 1-.1zm2-6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-1q.006-.507.121-1H4v1a1 1 0 1 0 2 0v-1h12v1a1 1 0 0 0 2 0v-1h1.879q.114.493.121 1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-car_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCar;
